export default "__VITE_ASSET__ysIXiyCQ__"